import React from 'react';
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import SEO from '../components/seo';
import '../styles/app.scss';

const schedule = ({ data }) => {
    const { wordpressPage: post } = data;
    console.log(post);
    const test_title = post.yoast_title;
    const new_test_title = test_title.replace('&#039;', "'");
    const inlineCss = {
        maxWidth: '600px',
        marginTop: '50px',
    };
    return (
        <>
            <SEO
                title={new_test_title}
                meta={post.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />

            <section className="page-section smallestwdt centersec">
                <div className="container">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: post.content,
                        }}
                    />
                </div>
            </section>
            <section className="whywelist page-section bg-primary text-white">
                <div className="container smallestwdt">
                    <h3 className="yellowtxt">Simple, Worry-Free Monthly Enrollment</h3>
                  {/*  <p style={{ marginTop: '30px' }}>With local university recreational options shifting this July, we are here to make your child's transition seamless, positive, and stress-free. At We Rock The Spectrum Piscataway, <strong>we never charge a registration fee!</strong> 🎁 <strong>Limited-Time Transfer Bonus:</strong> Buy a 6-week session today, and get <strong>1 bonus drop-in class completely free</strong> to keep their summer momentum going!</p> */}
                    <ul className="startxt starlistspacing" style={{ marginTop: '30px', textAlign: 'left' }}>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>We’ve streamlined our class enrollment to make keeping your child active completely seamless!</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Monthly Tuition: $120 / month (Includes 4 weekly classes per month)</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Sibling Discount: Save $15/month for each additional enrolled child ($225/month for 2 kids)</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Zero Registration Fees: We NEVER charge an added registration or sign-up fee!</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Exclusive Member Perk: Active Rockin' Tumblers members receive 10% OFF Open Play passes & Birthday Parties!</li>
                    </ul>
                    <h3 className="yellowtxt" style={{ marginTop: '30px' }}>Membership & Cancellation Terms</h3>
                    <p style={{ marginTop: '30px' }}><strong>Auto-Pay Commitment: </strong>Rockin' Tumblers is a monthly auto-pay program billed on the 1st of each calendar month following registration. To support student progression and consistency, all memberships require an initial 2-month minimum commitment.</p>
                    <p><strong>Cancellation Policy: </strong>After your initial 2-month term, you may cancel at any time by providing a 30-day written notice via email to info@werockthespectrumpiscataway.com.</p>
                </div>
            </section>
            <section className="whywelist page-section bg-secondary text-white">
                <div className="container smallestwdt">
                    <h2 className="yellowtxt">Fall Class Schedule</h2>
                 {/*   <p><strong>$160 per 6-Week Session</strong> (1 Class Per Week)</p> */}
                    <div className="schedule-table-wrap">
                        <table className="schedule-table">
                            <thead>
                                <tr>
                                    <th>Wednesday Evenings</th>
                              {/*      <th>Thursday Evenings</th> */}
                                    <th>Saturday Mornings</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label="Wednesday Evenings">
                                        <strong>Parent &amp; Tot</strong> (Ages 1–3)<br /><br />
                                        ⏱ 5:00 PM – 5:45 PM
                                    </td>
                              {/*      <td data-label="Thursday Evenings"></td> */}
                                    <td data-label="Saturday Mornings">
                                        <strong>Parent &amp; Tot</strong> (Ages 1–3)<br /><br />
                                        ⏱ 9:00 AM – 9:45 AM
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Wednesday Evenings">
                                        <strong>Preschool/Kinder</strong> (Ages 3–6)<br /><br />
                                        ⏱ 5:45 PM – 6:30 PM
                                    </td>
                           {/*         <td data-label="Thursday Evenings">
                                        <strong>Preschool/Kinder</strong> (Ages 3–6)<br /><br />
                                        ⏱ 5:45 PM – 6:30 PM
                                    </td> */}
                                    <td data-label="Saturday Mornings">
                                        <strong>Preschool/Kinder</strong> (Ages 3–6)<br /><br />
                                        ⏱ 9:50 AM – 10:30 AM
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            <section className="page-section smallestwdt respitesec padding-less-under">
                <div className="container">
                    <h2 className="bluetxt" style={{ marginBottom: '60px', textAlign: 'center' }}>What to Expect at Rockin' Tumblers</h2>
                    <div className="openplft">
                        <img
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/wp-content/uploads/2026/08/Fall-Rockin-Tumblers-2026.jpeg"
                            alt="Rockin' Tumblers Flyer"
                        />
                    </div>
                    <div className="openprgt withmarbtm">
                        <ul className="startxt starlistspacing">
                            <li className="greentxt">Structured Floor Circuits: <span className="bluetxt">High-energy warm-ups and focused gymnastics circuits designed to build core tumbling, balance, and fundamental coordination skills.</span></li>
                            <li className="greentxt">Safety-Certified Coaching: <span className="bluetxt">Led by fully background-checked, safety-certified, and tenured instructors who focus on positive skill building.</span></li>
                            <li className="greentxt">Non-Competitive & Just for Fun: <span className="bluetxt">A positive, growth-oriented environment designed to build physical skills and confidence all year long.</span></li>
                            <li className="greentxt">Parent Support Welcomed: <span className="bluetxt">Parents are always welcome to step in and support their little ones in Parent & Tot sessions as needed!</span></li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="whywelist page-section bg-secondary text-white">
                <div className="container smallestwdt">
                    <h3 className="text-white">Kids leave class feeling accomplished, confident, and eager to come back for more fun!</h3>
                </div>
            </section>
            <section
                className="whywelist page-section bg-primary text-white"
                id="contformsec"
            >
                <div className="container smallestwdt">
                    <h3 className="yellowtxt">Secure Your Gymnast's Spot Today</h3>
                    <p>Spots for our Fall classes are limited to keep class sizes small and impactful. Have questions about level placement or sibling discounts? Call us directly at <strong>732-339-8002</strong> or email <strong>info@werockthespectrumpiscataway.com</strong>.</p>
                    <div className="container flexwrap contactform_wrap">
                        <iframe
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/rockin-tumblers/"
                            title="contactform"
                        />
                    </div>
                </div>
            </section>
            
            <Footer />
        </>
    );
};

export default schedule;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            content            
            yoast_meta {
                name
                property
            }
            yoast_title
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;
